<template lang="pug">
.footer.q-pa-md
  Locale
</template>

<script>
import Locale from '@/components/LocaleSwitcher'

export default {
  components: {
    Locale
  }
}
</script>
